import useTabTitle from "app/hooks/useTabTitle";
import { useRoleForRoutes } from "auth";
import { GlobalContext } from "index";
import LoginPage from "pages/Login";
import React, { useContext } from "react";
import { ToastBar, Toaster } from "react-hot-toast";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import Router, { definedRoutes } from "routes";
import Theme, { theme } from "theme";

export default function App() {
  const { user } = useContext(GlobalContext);
  const navigate = useNavigate();
  const navToLogin = () => navigate("/login");
  React.useEffect(() => {
    window.addEventListener("navToLogin", navToLogin);
    return () => window.removeEventListener("navToLogin", navToLogin);
  }, []);
  let routes = useRoleForRoutes(user, definedRoutes);
  useTabTitle();
  const { getRemainingTime } = useIdleTimer({
    onIdle: () => {
      localStorage.removeItem("E1_JWT");
      dispatchEvent(new Event("storage"));
    },
    timeout: 1200000,
    throttle: 500
  });
  if (!user) {
    return (
      <Theme>
        <Toaster
          position="top-center"
          reverseOrder={true}
          toastOptions={{
            style: {
              borderRadius: "10px",
              background: theme.palette.primary.light,
              color: theme.palette.text.primary
            },
            success: {
              duration: 3000
            },
            error: {
              duration: 5000
            }
          }}
        />
        <LoginPage />
      </Theme>
    );
  }

  return (
    <Theme>
      <Toaster
        position="top-center"
        reverseOrder={true}
        toastOptions={{
          className: "toaster-notification",
          success: {
            duration: 3000
          },
          error: {
            duration: 5000
          }
        }}
      >
        {t => (
          <ToastBar toast={t}>
            {({ icon, message }) => {
              let msg = message?.props?.children || "";
              if (typeof msg !== "string") {
                msg = "";
              }
              return (
                <>
                  <div
                    className="toaster-notification-icon-container"
                    style={{
                      "--bg-color":
                        t.type === "error"
                          ? "linear-gradient(to right, #F43F5E, #EC4899)"
                          : ["loading", "info"].includes(t.type)
                          ? "linear-gradient(to bottom right, #7f3bf6, #7f3bf6c7)"
                          : "linear-gradient(to bottom right, #10b981, #14b8a6)"
                    }}
                  >
                    <div className="toaster-notification-icon">{icon}</div>
                  </div>
                  <div className="toaster-notification-message">
                    <div className="toaster-notification-message-header">
                      {msg?.split("\n")[0]}
                    </div>
                    {/* <div className="toaster-notification-message-caption">
                      {msg?.split("\n")[1] ||
                        (t.type === "error"
                          ? "error occurred"
                          : t.type === "loading"
                          ? "loading..."
                          : "success!")}
                    </div>*/}
                  </div>
                </>
              );
            }}
          </ToastBar>
        )}
      </Toaster>
      <Router routes={routes} />
    </Theme>
  );
}
